// extracted by mini-css-extract-plugin
module.exports = {"module":"_2wflc1xg p2","row":"t9AypUDn flex","label":"UIdv3Igz flex-auto","value":"_34DSASkA","buttons":"_3xC4HHnM flex mt2","button":"_1RPoRthh"};